import React from 'react';
import { motion } from 'framer-motion';
interface PageBannerProps {
  title: string;
  eyebrow: string;
  subtitle?: string;
  image: string;
}
export function PageBanner({
  title,
  eyebrow,
  subtitle,
  image
}: PageBannerProps) {
  return <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-271">
      <div className="absolute inset-0 z-0 bg-club-green" data-id="element-272">
        <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-273" />
        <div className="absolute inset-0 bg-club-navy/50 mix-blend-multiply" data-id="element-274"></div>
      </div>
      <div className="relative z-10 text-center px-4 mt-16" data-id="element-275">
        <motion.span className="eyebrow text-club-gold mb-4 block" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-276">
          {eyebrow}
        </motion.span>
        <motion.h1 className="text-5xl md:text-6xl font-serif text-white mb-4" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} data-id="element-277">
          {title}
        </motion.h1>
        {subtitle && <motion.p className="text-lg text-club-canvas/80 font-light max-w-2xl mx-auto" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} data-id="element-278">
            {subtitle}
          </motion.p>}
      </div>
    </section>;
}